var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLargePinCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.80188C0 5.77036 1.86733 3.05204 4.697 1.96433L8.53834 0.487752C9.37711 0.165336 10.268 0 11.1666 0H66.6747C70.7204 0 74 3.27965 74 7.3253V63.0555C74 63.8092 73.8837 64.5583 73.6552 65.2765L72.5036 68.8958C71.5364 71.9356 68.7131 74 65.5231 74H7.32529C3.27964 74 0 70.7204 0 66.6747V8.80188Z",
    fill: "#0E5CF4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.91566,
    y: 0.915662,
    width: 68.1687,
    height: 68.1687,
    rx: 6.40964,
    fill: "white",
    stroke: "#00193C",
    strokeWidth: 1.83132
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.91566,
    y: 0.915662,
    width: 68.1687,
    height: 68.1687,
    rx: 6.40964,
    stroke: "#00193C",
    strokeWidth: 1.83132
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#0E5CF4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 13,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#0E5CF4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 13,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#0E5CF4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 47,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#0E5CF4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 30,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#0E5CF4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 30,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#0E5CF4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 30,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#0E5CF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLargePinCode);
export default __webpack_public_path__ + "static/media/ic-large-pin-code.46b05b9621d97fd3fdc7e89d8e3577d9.svg";
export { ForwardRef as ReactComponent };